import { T_PRIVACY_POLICY_PAGE_CONSTANTS } from './TYPES'

const EN_PRIVACY_POLICY_PAGE_CONSTANTS: T_PRIVACY_POLICY_PAGE_CONSTANTS = {
  PAGE_KICKER: 'GRIFFYREADS',
  PAGE_TITLE: 'Privacy Policy',
  PAGE_CONTENT: [
    {
      TITLE: 'Introduction',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'ADONIS CONSULTANCY, as the owner and operator of the website www.griffyreads.com and the corresponding application GriffyReads ("the App"), informs visitors and registered users about its data processing practices, the appropriate technical and organisational measures implemented to protect personal data, and the available legal remedies for users.',
            'This Privacy Policy explains how your personal data is collected, used and safeguarded.',
            'By registering for the Application and creating an account, adult users give their explicit consent to the processing of their personal data, and, where applicable, to the processing of the personal data of any child for whom they create an account (linked account), in accordance with this Privacy Policy.'
          ]
        }
      ]
    },
    {
      TITLE: 'The Controller',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'The data controller is ADONIS CONSULTANCY (seat: Belgium, 1170 Watermael-Boitsfort, 16 avenue de l’Hermine), tax number: BE 0553 528 124, represented by the founder Ralph EL KHOURY) (“the Controller”).',
            'All personal data collected through the Controller’s services is stored and processed securely on servers hosted by Amazon Web Services (AWS) in the Europe (Ireland) Region (eu-west-1). Accordingly, all personal data are stored within the European Economic Area (EEA) and are protected under EU data protection legislation, including Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data (“GDPR”).'
          ]
        }
      ]
    },
    {
      TITLE:
        'The Data Processed by the Controller and the objectives of data processing',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'a)	Information at the time of Registration:',
            'The App is intended for use by both adults and children (in the App, registered children are referred to as “adventurers”; registered adults and children are collectively referred to as “users”). Users access the App through individual accounts.',
            ' ',
            'Only adults are permitted to initiate account creation by registering for the App. During registration, adult users are required to provide their full name, date of birth, language preference, email address, password, and a username. Once their account is created, adults may create linked accounts for their children or students by providing the same set of information. After a child’s account has been created, the child may log in and access the App independently.',
            ' ',
            ' ',
            'Those data are used:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'To provide access to the App and enable login',
            'To maintain and operate user accounts',
            'To personalise user experience, including character progression and leaderboard rankings'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Legal basis:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Article 6(1)(b) of the GDPR – Contract: Processing is necessary for the performance of a contract (providing access to and use of the App).',
            'Article 6(1)(f) of the GDPR – The Controller’s legitimate interest: To ensure the proper functioning of user accounts and prevent misuse.',
            'Regarding personal data of children under the age of 13 years, in accordance with Article 8 of the GDPR and Belgian law, parental consent is required. This is ensured by requiring that only an adult may create an account for a child in the App and that adult provides the necessary personal data on the child’s behalf.'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'b)	Data relating to quizzes:',
            ' ',
            'For the purpose of testing the reading comprehension of a book, adult users upload quizzes consisting of multiple-choice questions. After approval by an administrator, quizzes are stored in the App and become available for all users. The App stores information about the results of an adventurer, including points earned and progress.',
            ' ',
            ' ',
            'Those data are used:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'To provide the App’s core functionality (quizzes and progress tracking)',
            'To support educational and interactive features'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Legal basis:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Article 6(1)(b) of the GDPR  – Contract: For providing the core functionality of the App (quizzes and progress tracking).',
            'Article 6(1)(f) of the GDPR – The Controller’s legitimate interest: To support the educational and interactive purposes of the App.'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'c)	Data relating to Books Owned: ',
            ' ',
            'The App stores identification data about the books children indicate they own in their library and allows their exchange between children, promoting sustainability by encouraging the borrowing of books.',
            ' ',
            ' ',
            'Those date are used:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'To offer the virtual library feature',
            'To facilitate book exchange and promote borrowing'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Legal basis:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Article 6(1)(b) of the GDPR – Contract: To offer the library and book exchange feature.',
            'Article 6(1)(b) of the GDPR – Contract: To offer the library and book exchange feature.'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'd)	Communications:',
            ' ',
            'The Controller collects information from emails and push notifications sent for statistical purposes.',
            ' ',
            ' ',
            'Those data are used:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'To send updates, and information on events and competitions',
            'To analyse communication effectiveness and improve the App.'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Legal basis:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Article 6(1)(f) of the GDPR – The Controller’s legitimate interest: For analysing communication effectiveness and improving the App.'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'e)	Payment Information',
            ' ',
            'Payments of subscription fees are processed via PayPal. No payment data is stored on the Contoller’s platform.'
          ]
        }
      ]
    },
    {
      TITLE: 'Sharing Your Personal Data',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'The Controller does not sell, trade, or otherwise transfer your personal data to third parties, except as necessary to provide the App`s services, to comply with the prevailing legal requirements, or to protect its rights.'
          ]
        }
      ]
    },
    {
      TITLE: 'Data Security',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'The Controller implements appropriate security measures to protect your personal information from unauthorised access, alteration, disclosure, or destruction.'
          ]
        }
      ]
    },
    {
      TITLE: 'Your Rights',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'You have the right to request from the Controller access to and rectification or erasure of your personal data. You may also object to or restrict the processing of your data. To exercise these rights, please contact the Controller at contact@griffyreads.com.'
          ]
        }
      ]
    },
    {
      TITLE: 'Changes to This Privacy Policy',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'The Controller may update this Privacy Policy from time to time. The Controller will notify you of any changes by posting the new policy on its website. Your continued use of the App after such changes indicates your acceptance of the new Privacy Policy.'
          ]
        }
      ]
    },
    {
      TITLE: 'Contact Us',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'If you have any questions or concerns about this Privacy Policy, please contact the Controller at contact@griffyreads.com.'
          ]
        }
      ]
    },
    {
      TITLE: 'Right to Lodge a Complaint',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'If you consider that the processing of personal data relating to you infringes applicable data protection laws, you have the right to lodge a complaint with a supervisory authority.',
            '',
            '',
            'In Belgium, the competent authority is:',
            'Belgian Data Protection Authority',
            'Rue de la Presse 35, 1000 Brussels',
            '',
            '',
            'Website: https://www.dataprotectionauthority.be',
            '',
            '',
            '',
            'This Privacy Policy is effective as from 05 May, 2025.'
          ]
        }
      ]
    }
  ]
}

export default EN_PRIVACY_POLICY_PAGE_CONSTANTS
